import React, { useEffect, useRef, useState } from "react";
import './MessageFromUserCard.css';

// import {MdImage} from 'react-icons/md';
import {FaFilePdf} from 'react-icons/fa';
import {MdLocalMovies} from 'react-icons/md';
import {FaFileAlt} from 'react-icons/fa';
import { BiCheckDouble } from 'react-icons/bi';


const MessageFromUserCard = ({type, ext, msg, uploadedFile}) => {

    const userResponse = useRef(null);
    const [fileDataURL, setFileDataURL] = useState(null);


    //user response can be opted-button, input, document upload, audio input.

    useEffect(() => {
        userResponse.current.scrollIntoView();
        let fileReader, isCancel = false;
        // console.log(uploadedFile)
        if (uploadedFile) {
        fileReader = new FileReader();
        fileReader.onload = (e) => {
            const { result } = e.target;
            if (result && !isCancel) {
            setFileDataURL(result);
            }
        };
        fileReader.readAsDataURL(uploadedFile);
        }
        return () => {
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
            // cleanup
        };
    }, [uploadedFile]);

    // console.log(type)

    return(
        <div className="bot-chatbox-main-user" ref={userResponse}>
            <span style={{ "padding" : type === "image" ? "8px" : "8px 16px" }}>
                <div className= { type === "image" ? "bot-chatbox-main-user-msg doc" : "bot-chatbox-main-user-msg no-doc"} >
                {
                    type === "image" && (ext === "jpg" || ext === "png" || ext === "jpeg") ?
                    // <MdImage style={{"fontSize":"24px","marginRight": "8px"}}/>
                    <img className="bot-user-doc" src={fileDataURL} alt="preview" />
                    :
                    type === "application" && ext === "pdf" ?
                    <FaFilePdf style={{"fontSize":"24px","marginRight": "8px"}}/>
                    :
                    type === "video" ?
                    <MdLocalMovies style={{"fontSize":"24px","marginRight": "8px"}}/>
                    :
                    type === "button" || type === "input" || type === "agent" || type === "msg" ?
                    null
                    :
                    <FaFileAlt style={{"fontSize":"24px","marginRight": "8px"}}/>
                }
                {msg}
                </div>
                <div className="bot-chatbox-msg-status">
                    <p className="bot-bot-time">{new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                    <p style={{"fontSize":"18px"}}><BiCheckDouble/></p>
                </div>
            </span>
        </div>
    )
}

export default MessageFromUserCard;
